import Alpine from 'alpinejs';

Alpine.data('arrow', () => ({
    init() {
        new Arrow(this.$root);
    },
}));

class Arrow {
    constructor(element) {
        this.element = element;

        window.addEventListener('click', (e) => {
            e.target.contains(this.element) ? this.scrollDown() : null;
        });
    }

    scrollDown() {
        let parentSection = this.element.closest('section');
        let nextSection = parentSection.nextElementSibling;

        if (!nextSection) return;

        let cssHeaderHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        let offset = parseFloat(cssHeaderHeight) * 16 || 0; // rems to pixels

        window.scrollTo({
            top: nextSection.getBoundingClientRect().top + window.scrollY - offset,
            behavior: 'smooth',
        });
    }
}
